module.exports = __webpack_public_path__ + "assets/images/glasses-02.d071c65f38000bb6b30bc3fee474bcd8.svg";